import { riskPictureBadgeFill } from "./risk-picture-colors";
import type { RiskPictureKind, RiskPictureLevel } from "./risk-picture-model";

const VIEW = 64;

const badgeShape = (kind: RiskPictureKind, level: RiskPictureLevel | undefined): string => {
  const { fill, stripe } = riskPictureBadgeFill(kind, level);
  return stripe
    ? `<defs><pattern id="p" width="14" height="14" patternUnits="userSpaceOnUse" patternTransform="rotate(-45)"><rect width="14" height="14" fill="${fill}"/><rect width="6" height="14" fill="${stripe}" fill-opacity="0.45"/></pattern></defs><rect width="${VIEW}" height="${VIEW}" fill="url(#p)"/>`
    : `<rect width="${VIEW}" height="${VIEW}" fill="${fill}"/>`;
};

/** Colored square behind the phenomenon icon on map cards and in the popup. */
export const riskPictureBadgeUrl = (
  kind: RiskPictureKind,
  level: RiskPictureLevel | undefined,
): string => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${VIEW} ${VIEW}">${badgeShape(kind, level)}</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

/** Small-map badge: same code fill as the full map, plus its inset black ring. */
export const riskPictureThumbBadgeUrl = (
  kind: RiskPictureKind,
  level: RiskPictureLevel | undefined,
): string => {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${VIEW}" height="${VIEW}" viewBox="0 0 ${VIEW} ${VIEW}"><clipPath id="c"><rect width="${VIEW}" height="${VIEW}" rx="12"/></clipPath><g clip-path="url(#c)">${badgeShape(kind, level)}</g><rect x="2" y="2" width="60" height="60" rx="10" fill="none" stroke="#000" stroke-width="4"/></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};
